
import { Dialog, DialogContent as BaseDialogContent } from "@/components/ui/dialog";
import { useAuth } from "@/components/AuthProvider";
import { DialogContent } from "./subscription/components/DialogContent";
import { useSubscriptionDialog } from "./subscription/hooks/useSubscriptionDialog";

interface SubscriptionDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  userId: string;
  showPlansInitially?: boolean;
}

export const SubscriptionDialog = ({
  open,
  onOpenChange,
  userId,
  showPlansInitially = false
}: SubscriptionDialogProps) => {
  const { user } = useAuth();
  const userEmail = user?.email;

  const {
    selectedPlan,
    isAnnual,
    setIsAnnual,
    isLoading,
    isPlansLoading,
    planConfigs,
    isPortalLoading,
    isDowngradeLoading,
    updateComplete,
    isRedirecting,
    downgradeSuccess,
    downgradeMessage,
    subscriptionStatus,
    handleConfirmPlan,
    handleOpenBillingPortal,
    handleDowngrade,
    setSelectedPlan
  } = useSubscriptionDialog(userId, userEmail);

  // Extract pending downgrade info from subscription status
  const pendingDowngrade = subscriptionStatus?.metadata?.pending_downgrade === true;
  const nextPlan = subscriptionStatus?.metadata?.next_plan as string;
  const downgradeDate = subscriptionStatus?.metadata?.downgrade_effective_date ? 
    new Date(subscriptionStatus.metadata.downgrade_effective_date).toLocaleDateString('en-US', {
      year: 'numeric', month: 'long', day: 'numeric'
    }) : subscriptionStatus?.current_period_end ? 
    new Date(subscriptionStatus.current_period_end).toLocaleDateString('en-US', {
      year: 'numeric', month: 'long', day: 'numeric'
    }) : null;

  // Create a wrapper function to convert the setState function to the expected function signature
  const handlePlanSelection = (plan: string) => {
    setSelectedPlan(plan as any); // Using type assertion as a temporary fix
  };

  return (
    <Dialog 
      open={open}
      onOpenChange={(newOpen) => {
        if (!isLoading && !updateComplete && !isRedirecting && !isDowngradeLoading) {
          onOpenChange(newOpen);
        }
      }}
    >
      <BaseDialogContent 
        className="w-[900px] max-w-[90vw] p-4"
        showCloseButton={!isLoading && !updateComplete && !isRedirecting && !isDowngradeLoading}
      >
        <DialogContent
          isPlansLoading={isPlansLoading}
          updateComplete={updateComplete}
          isRedirecting={isRedirecting}
          isDowngradeLoading={isDowngradeLoading}
          downgradeSuccess={downgradeSuccess}
          downgradeMessage={downgradeMessage}
          selectedPlan={selectedPlan}
          handlePlanSelection={handlePlanSelection}
          handleConfirmPlan={handleConfirmPlan}
          handleOpenBillingPortal={handleOpenBillingPortal}
          handleDowngrade={handleDowngrade}
          isLoading={isLoading}
          isPortalLoading={isPortalLoading}
          hasConfigs={!!planConfigs}
          isAnnual={isAnnual}
          setIsAnnual={setIsAnnual}
          pendingDowngrade={pendingDowngrade}
          nextPlan={nextPlan}
          downgradeDate={downgradeDate}
        />
      </BaseDialogContent>
    </Dialog>
  );
};
